// Shire of Coorow booking strategy (Escapia tenant bookings-shireofcoorow).
//
// A site's reserveUrl is its Escapia unit page (/Unit/Details/{unitId}).
// The link goes one step deeper, to checkout step 1 of 3 —
// /Booking/RateDetails/{unitId}?arrive=DD/MM/YYYY&depart=DD/MM/YYYY&adults=N
// &children=0&pets=None — which names the site, the stay, the party and
// the total, with the rental-policy box to tick before step 2. The unit
// page's own "Continue Booking" form submits exactly these fields. Without
// the party fields the page errors ("Booking Information Error"), and a
// stay that is no longer free lands on "Unit Unavailable".

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

const escapiaDate = (date) => format(date, "dd/MM/yyyy");

// The unit page's party picker defaults to 1 adult; 2 is the fleet's
// camping default and every site sleeps at least 4.
const DEFAULT_ADULTS = 2;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate, partySize } = ctx;
    const unitUrl = new URL(site.reserveUrl);
    const unitId = unitUrl.pathname.match(/\/Unit\/Details\/(\d+)/)?.[1];
    if (!unitId) return site.reserveUrl;
    const url = new URL(`/Booking/RateDetails/${unitId}`, unitUrl.origin);
    url.searchParams.set("arrive", escapiaDate(arrivalDate));
    url.searchParams.set("depart", escapiaDate(resolveCheckout(ctx)));
    url.searchParams.set("adults", String(partySize ?? DEFAULT_ADULTS));
    url.searchParams.set("children", "0");
    url.searchParams.set("pets", "None");
    return url.toString();
  },

  // The tenant's unit list filtered to the campground's Location
  // (`default.aspx?cat2=<locationId>`) is the facility overview; the
  // reserveUrl is one unit's page.
  buildPreviewUrl(site, facility) {
    const locationId = facility?.extraAttributes?.locationId;
    const url = new URL("/default.aspx", site.reserveUrl);
    if (locationId) url.searchParams.set("cat2", String(locationId));
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as ?arrive=<dd/MM/yyyy>.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &depart=<dd/MM/yyyy>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes: "The unit id comes from site.reserveUrl (/Unit/Details/{id}).",
        },
        partySize: {
          status: "defaulted",
          defaultValue: DEFAULT_ADULTS,
          notes:
            "Encoded as &adults=<N>&children=0; checkout refuses more than the unit sleeps (6 per campsite, 4 per chalet).",
        },
      },
    };
  },
};
